__webpack_require__.p = "/ototo/pokemon2026/game/";